var myJson = {};

function initSlickCarousel() {
	jQuery(".label-slider").slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"></button>',
		nextArrow: '<button class="slick-next"></button>',
		dots: !0,
      	adaptiveHeight: false,
		dotsClass: "slick-dots"
	}), jQuery(".product-slider").slick({
		slidesToScroll: 1,
		rows: 0,
		slidesToShow: 3,
		prevArrow: '<a href="#" class="slick-prev">Previous</a>',
		nextArrow: '<a href="#" class="slick-next">Next</a>',
		dots: !0,
		dotsClass: "slick-dots",
		responsive: [{
			breakpoint: 1024,
			settings: {
				slidesToShow: 2
			}
		}, {
			breakpoint: 768,
			settings: {
				slidesToShow: 1
			}
		}]
	}), jQuery(".images-slider").slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"></button>',
		nextArrow: '<button class="slick-next"></button>',
		dots: !0,
		dotsClass: "slick-dots",
		autoplay: !0
	}), jQuery('.mn-slider').slick({
		slidesToScroll: 1,
		rows: 0,
		prevArrow: '<button class="slick-prev"></button>',
		nextArrow: '<button class="slick-next"></button>'
	}), jQuery('.visual-awards-slider').slick({
        slidesToScroll: 1,
        rows: 0,
        autoplay: false,
        slidesToShow: 1,
        dots: true,
        prevArrow: '<a href="#" class="slick-prev"></a>',
        nextArrow: '<a href="#" class="slick-next"></a>'
    });

    jQuery(".popup-carousel").slick({
        slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: '<button class="slick-prev"></button>',
		nextArrow: '<button class="slick-next"></button>',
		dots: true,
		dotsClass: "slick-dots",
        infinite: true,
		autoplay: true,
        autoplaySpeed: 1000
    });
  
}
//  jQuery(document).on("click",".wine-popup-opener",function() {
//     var cureent = $(this).attr('data-state');
//    jQuery('.wine-slider').hide();
//    jQuery('#'+cureent).show();
//    	jQuery('#'+cureent).slick({
//         slidesToScroll: 1,
//         rows: 0,
//         prevArrow: '<button class="slick-prev">Previous</button>',
//         nextArrow: '<button class="slick-next">Next</button>',
//         dots: true,
//         dotsClass: 'slick-dots'
//     })
// });
jQuery(document).on("click",".wine-popup-close",function(e) {
      e.preventDefault();
      jQuery("body").removeClass("wine-popup-active");
    });

jQuery(document).on("click",".btn-fixed.wa-widget-toggle",function(e) {
  e.preventDefault();
  jQuery(".wa-multi-widget").toggleClass("hide");
  jQuery(".wa-widget-toggle").toggleClass("wa-close-state");
});


jQuery(document).on("click",".agp__button",function(e) {
	if(jQuery(e.currentTarget).prop('value') == 'No') {
  	window.location.href = "https://moonshinehoneyproject.com/";
  }
})

function initFaqAccordion() {
	jQuery(".accordion__title").on("click", function(e) {

		e.preventDefault();
		var $this = $(this);

		if (!$this.hasClass("accordion-active")) {
			jQuery(".accordion__content").slideUp(400);
			jQuery(".accordion__title").removeClass("accordion-active");
			jQuery('.accordion__arrow').removeClass('accordion__rotate');
		}

		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
		jQuery('.accordion__arrow',this).toggleClass('accordion__rotate');
	});
}

function initMobileNav() {
	jQuery("body").mobileNav({
		menuActiveClass: "tour-active",
		menuOpener: ".tour-opener, .tour-close",
		hideOnClickOutside: !0,
		menuDrop: ".popup-area"
	});
  
	jQuery("body").mobileNav({
		menuActiveClass: "terms-active",
		menuOpener: ".terms-opener, .terms-close",
		hideOnClickOutside: !0,
		menuDrop: ".terms-modal-area"
	});

  
	jQuery("body").mobileNav({
		menuActiveClass: "wine-popup-active",
		menuOpener: ".wine-popup-opener, .wine-popup-close",
		hideOnClickOutside: !0,
		menuDrop: ".stores-container"
	});

    jQuery('body').mobileNav({
		menuActiveClass: 'visual-awards-active',
		menuOpener: '.visual-awards-opener, .visual-awards-close',
		hideOnClickOutside: false
	});

    jQuery('.book-btn-close').click(function(e){
      e.preventDefault();
      jQuery(this).parents('.book-appointment').hide();
    });

	jQuery('.visual-awards-opener').click(function(){
		let _parent = jQuery(this).parent().index() + 1;
		jQuery('.visual-awards-slider .slick-dots li:nth-child('+_parent+') button').click();
	});
}

// accordion menu init
function initAccordion() {
	jQuery('.accordion').slideAccordion({
		opener: '.opener',
		slider: '.acc-slide',
		animSpeed: 300,
	});
}


function setCookie(key, value, expiry) 
{
        var expires = new Date();
        expires.setTime(expires.getTime() + (expiry * 24 * 60 * 60 * 1000));
        document.cookie = key + '=' + value + ';expires=' + expires.toUTCString();
}
function getCookie(key) 
{
        var keyValue = document.cookie.match('(^|;) ?' + key + '=([^;]*)(;|$)');
        return keyValue ? keyValue[2] : null;
}
setTimeout(function()
{
  var is_exist = getCookie('popup');

  if(is_exist ==null)
  {
    jQuery('.book-appointment').show();
    setCookie('popup','1','15');
  }
  else
  {
    jQuery('.book-appointment').hide();
  }


}, 5000);

jQuery(function() {
       console.log("hhhhhh");
		initSlickCarousel(),initFaqAccordion(), initAccordion(), initMobileNav(), jQuery("#cityDiv").show(), jQuery("#areaDiv").hide(), jQuery("#addressDiv").show(), jQuery("#pincodeDiv").hide(), jQuery("#product1Div").hide(), jQuery("#product2Div").hide(), jQuery("#product3Div").hide(), jQuery("#product4Div").hide(), jQuery("#serviceDiv").hide(), jQuery("#advertisementDiv").hide(), jQuery("#working_hrDiv").hide(), jQuery("#commentDiv").hide(), jQuery("#ratingDiv").hide(), jQuery("#newsDiv").hide(), myJson = {
			city: [{
				name: "Mumbai",
				id: "mumbai",
				areas: [{
					name: "Andheri East (Marol, Sakinaka) - 6 pints MOQ",
					id: "Andheri East (Marol, Sakinaka) - 6 pints MOQ",
					flag: 1
				}, {
					name: "Andheri West - 6 pints MOQ",
					id: "Andheri West - 6 pints MOQ"
				}, {
					name: "Bandra East - 8 pints MOQ",
					id: "Bandra East - 8 pints MOQ"
				}, {
					name: "Bandra West - 6 pints MOQ",
					id: "Bandra West - 6 pints MOQ",
					flag: 1
				}, {
					name: "Bhandup - 6 pints MOQ",
					id: "Bhandup - 6 pints MOQ"
				}, {
					name: "Borivali & Kandivali- 6 pints MOQ",
					id: "Borivali & Kandivali- 6 pints MOQ"
				}, {
					name: "Chembur - 6 pints MOQ",
					id: "Chembur - 6 pints MOQ",
					flag: 1
				}, {
					name: "Colaba -12 pints MOQ",
					id: "Colaba -12 pints MOQ"
				}, {
					name: "Dadar- Mahim & Matunga - 6 pints MOQ",
					id: "Dadar- Mahim & Matunga - 6 pints MOQ",
					flag: 1
				}, {
					name: "Dahisar - 8 pints MOQ",
					id: "Dahisar - 8 pints MOQ",
					flag: 1
				}, {
					name: "Goregaon East & West - 6 pints MOQ",
					id: "Goregaon East & West - 6 pints MOQ",
					flag: 1
				}, {
					name: "Grant Road - 12 pints MOQ",
					id: "Grant Road - 12 pints MOQ"
				}, {
					name: "Juhu & Vile Parle - 6 pints MOQ",
					id: "Juhu & Vile Parle - 6 pints MOQ"
				}, {
					name: "Lokhandwala & Oshiwara - 6 pints MOQ",
					id: "Lokhandwala & Oshiwara - 6 pints MOQ"
				}, {
					name: "Lower Parel - 8 pints MOQ",
					id: "Lower Parel - 8 pints MOQ"
				}, {
					name: "Malad - 6 pints MOQ",
					id: "Malad - 6 pints MOQ",
					flag: 1
				}, {
					name: "Mulund - 6 pints MOQ",
					id: "Mulund - 6 pints MOQ"
				}, {
					name: "Mira Road - 12 pints MOQ",
					id: "Mira Road - 12 pints MOQ"
				}, {
					name: "Nariman Point -12 pints MOQ",
					id: "Nariman Point -12 pints MOQ"
				}, {
					name: "Parel - 8 pints MOQ",
					id: "Parel - 8 pints MOQ"
				}, {
					name: "Powai - 6 pints MOQ",
					id: "Powai - 6 pints MOQ"
				}, {
					name: "Prabhadevi - 6 pints MOQ",
					id: "Prabhadevi - 6 pints MOQ",
					flag: 1
				}, {
					name: "Santacruz East - 8 pints MOQ",
					id: "Santacruz East - 8 pints MOQ"
				}, {
					name: "Santacruz West - 6 pints MOQ",
					id: "Santacruz West - 6 pints MOQ",
					flag: 1
				}, {
					name: "Sion - 8 pints MOQ",
					id: "Sion - 8 pints MOQ"
				}, {
					name: "Tardeo - 8 pints MOQ",
					id: "Tardeo - 8 pints MOQ"
				}, {
					name: "Warden Road - 8 pints MOQ",
					id: "Warden Road - 8 pints MOQ"
				}, {
					name: "Worli - 6 pints MOQ",
					id: "Worli - 6 pints MOQ",
					flag: 1
				}, {
					name: "Versova - 6 pints MOQ",
					id: "Versova - 6 pints MOQ"
				}]
			}, {
				name: "Pune",
				id: "pune",
				areas: [{
					name: "Akurdi - 6 pints MOQ",
					id: "Akurdi - 6 pints MOQ"
				}, {
					name: "Amanora Park - 10 pints MOQ",
					id: "Amanora Park - 10 pints MOQ"
				}, {
					name: "Aundh - 6 pints MOQ",
					id: "Aundh - 6 pints MOQ"
				}, {
					name: "Balewadi - 6 pints MOQ",
					id: "Balewadi - 6 pints MOQ"
				}, {
					name: "Baner - 6 pints MOQ",
					id: "Baner - 6 pints MOQ"
				}, {
					name: "Bavdhan - 6 pints MOQ",
					id: "Bavdhan - 6 pints MOQ"
				}, {
					name: "Camp - 6 pints MOQ",
					id: "Camp - 6 pints MOQ"
				}, {
					name: "Chinchwad - 6 pints MOQ",
					id: "Chinchwad - 6 pints MOQ"
				}, {
					name: "Deccan - 6 pints MOQ",
					id: "Deccan - 6 pints MOQ"
				}, {
					name: "Dhanori - 6 pints MOQ",
					id: "Dhanori - 6 pints MOQ"
				}, {
					name: "FC Road - 6 pints MOQ",
					id: "FC Road - 6 pints MOQ"
				}, {
					name: "Hadapsar - 10 pints MOQ",
					id: "Hadapsar - 10 pints MOQ"
				}, {
					name: "Hinjewadi - 6 pints MOQ",
					id: "Hinjewadi - 6 pints MOQ"
				}, {
					name: "Kalyaninagar - 6 pints MOQ",
					id: "Kalyaninagar - 6 pints MOQ"
				}, {
					name: "Karve Nagar - 6 pints MOQ",
					id: "Karve Nagar - 6 pints MOQ"
				}, {
					name: "Katraj - 6 pints MOQ",
					id: "Katraj - 6 pints MOQ"
				}, {
					name: "Kharadi - 6 pints MOQ",
					id: "Kharadi - 6 pints MOQ"
				}, {
					name: "Kondhwa - 6 pints MOQ",
					id: "Kondhwa - 6 pints MOQ"
				}, {
					name: "Koregaon Park - 6 pints MOQ",
					id: "Koregaon Park - 6 pints MOQ"
				}, {
					name: "Kothrud - 6 pints MOQ",
					id: "Kothrud - 6 pints MOQ"
				}, {
					name: "Lohegaon - 6 pints MOQ",
					id: "Lohegaon - 6 pints MOQ"
				}, {
					name: "Magarpatta City - 6 pints MOQ",
					id: "Magarpatta City - 6 pints MOQ"
				}, {
					name: "Mira Road - 12 pints MOQ",
					id: "Mira Road - 12 pints MOQ"
				}, {
					name: "Mundhwa - 6 pints MOQ",
					id: "Mundhwa - 6 pints MOQ"
				}, {
					name: "Nigdi - 6 pints MOQ",
					id: "Nigdi - 6 pints MOQ"
				}, {
					name: "Pashan - 6 pints MOQ",
					id: "Pashan - 6 pints MOQ"
				}, {
					name: "Pimple Gurav - 10 pints MOQ",
					id: "Pimple Gurav - 10 pints MOQ"
				}, {
					name: "Pimple Nilakh - 6 pints MOQ",
					id: "Pimple Nilakh - 6 pints MOQ"
				}, {
					name: "Pimple Saudagar - 10 pints MOQ",
					id: "Pimple Saudagar - 10 pints MOQ"
				}, {
					name: "Pimpri - 6 pints MOQ",
					id: "Pimpri - 6 pints MOQ"
				}, {
					name: "Punawale - 6 pints MOQ",
					id: "Punawale - 6 pints MOQ"
				}, {
					name: "Ravet - 6 pints MOQ",
					id: "Ravet - 6 pints MOQ"
				}, {
					name: "Senapati Bapat road - 6 pints MOQ",
					id: "Senapati Bapat road - 6 pints MOQ"
				}, {
					name: "Shivaji Nagar - 6 pints MOQ",
					id: "Shivaji Nagar - 6 pints MOQ"
				}, {
					name: "Sinhagad Road - 6 pints MOQ",
					id: "Sinhagad Road - 6 pints MOQ"
				}, {
					name: "Swargate - 6 pints MOQ",
					id: "Swargate - 6 pints MOQ"
				}, {
					name: "Viman Nagar - 6 pints MOQ",
					id: "Viman Nagar - 6 pints MOQ"
				}, {
					name: "Wadhgaon Sheri - 6 pints MOQ",
					id: "Wadhgaon Sheri - 6 pints MOQ"
				}, {
					name: "Wakad - 6 pints MOQ",
					id: "Wakad - 6 pints MOQ"
				}, {
					name: "Wanowrie - 6 pints MOQ",
					id: "Wanowrie - 6 pints MOQ"
				}, {
					name: "Warje - 6 pints MOQ",
					id: "Warje - 6 pints MOQ"
				}]
			}, {
				name: "Thane",
				id: "thane",
				areas: [{
					name: "Thane Manpada -  8 pints MOQ",
					id: "Thane Manpada -  8 pints MOQ"
				}, {
					name: "Thane Manpada -  8 pints MOQ",
					id: "Thane Manpada -  8 pints MOQ"
				}, {
					name: "Wagle Estate -  8 pints MOQ",
					id: "Wagle Estate -  8 pints MOQ"
				}, {
					name: "Kalwa -  8 pints MOQ",
					id: "Kalwa -  8 pints MOQ"
				}, {
					name: "Gorbhunder road -  8 pints MOQ",
					id: "Gorbhunder road -  8 pints MOQ"
				}, {
					name: "Upvan lake -  8 pints MOQ",
					id: "Upvan lake -  8 pints MOQ"
				}, {
					name: "Bhayandar pada -  8 pints MOQ",
					id: "Bhayandar pada -  8 pints MOQ"
				}, {
					name: "Kasarvadavali -  8 pints MOQ",
					id: "Kasarvadavali -  8 pints MOQ"
				}]
			}]
		}, jQuery.each(myJson.city, function(i, e) {
			jQuery("#city").append('<option value="' + e.id + '">' + e.name + "</option>")
		}), jQuery.each(myJson.city, function(i, e) {
			var t = e.id.split("-")[0],
				e = e.name.split("-")[0];
			jQuery("#citySubko").append('<option value="' + t + '">' + e + "</option>")
		})
	}), jQuery("#city").on("change", function() {
		console.log(jQuery(this).val());
		for(var i = 0; i < myJson.city.length; i++) myJson.city[i].id == jQuery(this).val() && (jQuery("#area").html('<option value="">-Select Area-</option>'), jQuery.each(myJson.city[i].areas, function(i, e) {
			var t = null != e.flag ? e.flag : 0;
			jQuery("#area").append('<option data-flag="' + t + '" value="' + e.id + '">' + e.name + "</option>")
		}))
	}), jQuery("#flavours input[name='flavours']").on("change", function() {
		if(!jQuery(this).is(':checked')) {
			jQuery(this).closest('li').find('.qty-inp').val('');
		}
		var tot = 0;
		jQuery("#flavours input.qty-inp").each(function() {
			if(jQuery(this).val())
				tot += parseInt(jQuery(this).val());
		})
		jQuery('#totalPints').html(tot);
	}), jQuery("#flavours input.qty-inp").on("keyup", function() {
		jQuery(this).closest('li').find('input[name="flavours"]').prop('checked', 'true');
		var tot = 0;
		jQuery("#flavours input.qty-inp").each(function() {
			if(jQuery(this).val())
				tot += parseInt(jQuery(this).val());
		})
		jQuery('#totalPints').html(tot);
	}), jQuery("#flavours input.qty-inp").on("change", function() {
		jQuery(this).closest('li').find('input[name="flavours"]').prop('checked', 'true');
		var tot = 0;
		jQuery("#flavours input.qty-inp").each(function() {
			if(jQuery(this).val())
				tot += parseInt(jQuery(this).val());
		})
		jQuery('#totalPints').html(tot);
	}), jQuery(".slide-opener").on("click", function(i) {
		i.preventDefault(), jQuery(this).parent().find(".slide").slideToggle()
	}), jQuery("#citySubko").on("change", function() {
		console.log(jQuery(this).val());
		for(var i = 0; i < myJson.city.length; i++) myJson.city[i].id == jQuery(this).val() && (jQuery("#areaSubko").html('<option value="">-Select Area-</option>'), jQuery.each(myJson.city[i].areas, function(i, e) {
			var t = e.id.split("-")[0],
				e = e.name.split("-")[0];
			jQuery("#areaSubko").append('<option value="' + t + '">' + e + "</option>")
		}))
	}), jQuery(document).on("click", "#close", function(i) {
		i.preventDefault(), document.getElementById("homePopup").style.display = "none"
	}), jQuery(document).on("click", ".float", function(i) {
		i.preventDefault(), document.getElementById("homePopup").style.display = "block", $(".label-slider").slick("refresh")
	}), jQuery(document).on("change", "#use_service", function(i) {
		i.preventDefault(), "yes" == jQuery(this).val() ? (jQuery("#advertisementDiv").show(), jQuery("#ratingDiv").show()) : (jQuery("#advertisementDiv").hide(), jQuery("#ratingDiv").hide())
	}), jQuery(document).on("change", "#type", function(i) {
		i.preventDefault();
		i = jQuery(this).val();
		"order" == i ? (jQuery("#cityDiv").show(), jQuery("#areaDiv").show(), jQuery("#addressDiv").show(), jQuery("#pincodeDiv").show(), jQuery("#product1Div").show(), jQuery("#product2Div").show(), jQuery("#product3Div").show(), jQuery("#product4Div").show(), jQuery("#serviceDiv").show(), jQuery("#advertisementDiv").hide(), jQuery("#commentDiv").hide(), jQuery("#working_hrDiv").hide(), jQuery("#cityeDiv").hide(), jQuery("#newsDiv").show()) : ("enquiry" == i || 'find meads near me'==i) && (jQuery("#cityDiv").hide(), jQuery("#cityeDiv").show(), jQuery("#areaDiv").hide(), jQuery("#commentDiv").show(), jQuery("#pincodeDiv").hide(), jQuery("#product1Div").hide(), jQuery("#product2Div").hide(), jQuery("#product3Div").hide(), jQuery("#product4Div").hide(), jQuery("#serviceDiv").hide(), jQuery("#advertisementDiv").hide(), jQuery("#working_hrDiv").show(), jQuery("#ratingDiv").hide(), jQuery("#newsDiv").show())
	}), jQuery(document).on("click", ".close-popup", function(i) {
		jQuery("#homePopup").hide()
	}), jQuery("form#form").submit(function() {
		var i = jQuery(this).find("input:visible"),
			n = !1,
			r = /^[^\s()<>@,;:\/]+@\w[\w\.-]+\.[a-z]{2,}$/i,
			e = jQuery(this).find("select:visible"),
			t = jQuery(this).find("textarea:visible"),
			inpSets = jQuery("#flavours, #checkDelivery, #ackLegal");
		if(i.each(function() {
				var i = $(this);
				if(void 0 !== (t = i.attr("data-rule"))) {
					var e, t, s = !1,
						o = t.indexOf(":", 0);
					switch(t = 0 <= o ? (e = t.substr(o + 1, t.length), t.substr(0, o)) : t.substr(o + 1, t.length)) {
						case "required":
							"" === i.val() && (n = s = !0);
							break;
						case "minlen":
							i.val().length < parseInt(e) && (n = s = !0);
							break;
						case "email":
							r.test(i.val()) || (n = s = !0);
							break;
						case "checked":
							i.attr("checked") || (n = s = !0);
							break;
						case "regexp":
							(e = new RegExp(e)).test(i.val()) || (n = s = !0)
					}
					i.next(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? void 0 !== i.attr("data-msg") ? i.attr("data-msg") : "wrong Input" : "")).show(), s ? i.next(".validation").show() : i.next(".validation").hide()
				}
			}), t.each(function() {
				var i = jQuery(this);
				if(void 0 !== (t = i.attr("data-rule"))) {
					var e, t, s = !1,
						o = t.indexOf(":", 0);
					switch(t = 0 <= o ? (e = t.substr(o + 1, t.length), t.substr(0, o)) : t.substr(o + 1, t.length)) {
						case "required":
							"" === i.val() && (n = s = !0);
							break;
						case "minlen":
							i.val().length < parseInt(e) && (n = s = !0)
					}
					i.next(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? null != i.attr("data-msg") ? i.attr("data-msg") : "wrong Input" : "")).show(), s ? i.next(".validation").show() : i.next(".validation").hide()
				}
			}), e.each(function() {
				var i = jQuery(this);
				if(void 0 !== (t = i.attr("data-rule"))) {
					var e, t, s = !1,
						o = t.indexOf(":", 0);
					switch(t = 0 <= o ? (e = t.substr(o + 1, t.length), t.substr(0, o)) : t.substr(o + 1, t.length)) {
						case "optional-required":
							"" === jQuery("#product1").val() && "" === jQuery("#product2").val() && "" === jQuery("#product3").val() && "" === jQuery("#product4").val() && (n = s = !0);
							break;
						case "required":
							!i.val() && (n = s = !0);
							break;
						case "minlen":
							i.val().length < parseInt(e) && (n = s = !0)
					}
					i.next(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? null != i.attr("data-msg") ? i.attr("data-msg") : "wrong Input" : "")).show(), s ? i.next(".validation").show() : i.next(".validation").hide()
				}
			}), inpSets.each(function() {
				var i = jQuery(this);
				if(void 0 !== (t = i.attr("data-rule"))) {
					var e, t, s = !1,
						o = t.indexOf(":", 0);

					switch(t = 0 <= o ? (e = t.substr(o + 1, t.length), t.substr(0, o)) : t.substr(o + 1, t.length)) {
						case "required":
							i.find('input[type="checkbox"]:checked, input[type="radio"]:checked').length == 0 && (n = s = !0);
							break;
					}
					i.find(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? null != i.attr("data-msg") ? i.attr("data-msg") : "wrong Input" : "")).show(), s ? i.find(".validation").show() : i.find(".validation").hide()
				}

				if(jQuery(this).attr('id') == 'flavours') {
					var qtyMsg = "Enter quantity for selected mead";
					var checkedFlavours = jQuery(this).find('input[name="flavours"]:checked')
					checkedFlavours.each(function(ind,elem) {
						if(jQuery(elem).closest('li').find('.qty-inp').val() < 1) {
							n = s = !0;
							i.find(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? qtyMsg : "")).show(), s ? i.find(".validation").show() : i.find(".validation").hide()
							return false;
						}
					});
				}

			}), n) return !1; {
			// var s = jQuery("#area option:selected").val(),
			// 	o = jQuery("#area option:selected").attr("data-flag"),
			// 	a = s.replace(/[^0-9]/g, ""),
			// 	i = "" != (i = jQuery("#product1 option:selected").val()) ? i : 0,
			// 	t = "" != (t = jQuery("#product2 option:selected").val()) ? t : 0,
			// 	e = "" != (e = jQuery("#product3 option:selected").val()) ? e : 0,
			// 	s = "" != (s = jQuery("#product4 option:selected").val()) ? s : 0;
			// 1 == o && 0 != s && (a = 6);
			// e = parseInt(i) + parseInt(t) + parseInt(e) + parseInt(s);
			// if(e < a) {
			// 	e = a - e;
			// 	return e = 1 == o && 0 != s ? "When you select a seasonal mead, the MOQ for your order is automatically bumped upto 6. Please add at least " + e + " more pints to place your order." : "Please add at least " + e + " more pints to place your order", swal({
			// 		text: e,
			// 		icon: "info",
			// 		button: "OK"
			// 	}), !1
			// }

			var formDataSerialized = $('input[name!=flavours], select, textarea', $('#form')).serializeArray();
      
      $('#flavours input[name="flavours"]').each(function(ind, elem){
      		formDataSerialized.push({
      			'name': 'flavour' + (ind+1),
      			'value': $(this).val() + " (" + ($(this).closest('li').find('.qty-inp').val() || 0) + ")"
      		});
      });
      

			const l = document.forms["save-form"];
			$.blockUI({
				css: {
					border: "none",
					padding: "15px",
					backgroundColor: "#000",
					"-webkit-border-radius": "10px",
					"-moz-border-radius": "10px",
					fontSize: "12px",
					opacity: .5,
					color: "#fff"
				}
			}), $.ajax({
				url: "https://us-central1-moonshine-meadery-website.cloudfunctions.net/enquiry/test",
				type: "POST",
				crossDomain: !0,
				dataType: "json",
				data: formDataSerialized,
				success: function(i) {
					$.unblockUI();l.reset();$.growlUI("Enquiry Submitted Successfully!"); location.reload();
				},
				error: function(i, e, t) {
					console.log(i, e, t)
				}
			})
		}
		return !1
	}), jQuery("form[name='save-subko-form']").submit(function() {
		var i = jQuery(this).find("input:visible"),
			n = !1,
			r = /^[^\s()<>@,;:\/]+@\w[\w\.-]+\.[a-z]{2,}$/i,
			e = jQuery(this).find("select:visible"),
			t = jQuery(this).find("textarea:visible");
		if(i.each(function() {
				var i = $(this);
				if(void 0 !== (t = i.attr("data-rule"))) {
					var e, t, s = !1,
						o = t.indexOf(":", 0);
					switch(t = 0 <= o ? (e = t.substr(o + 1, t.length), t.substr(0, o)) : t.substr(o + 1, t.length)) {
						case "required":
							"" === i.val() && (n = s = !0);
							break;
						case "minlen":
							i.val().length < parseInt(e) && (n = s = !0);
							break;
						case "email":
							r.test(i.val()) || (n = s = !0);
							break;
						case "checked":
							i.attr("checked") || (n = s = !0);
							break;
						case "regexp":
							(e = new RegExp(e)).test(i.val()) || (n = s = !0)
					}
					i.next(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? void 0 !== i.attr("data-msg") ? i.attr("data-msg") : "wrong Input" : "")).show(), s ? i.next(".validation").show() : i.next(".validation").hide()
				}
			}), t.each(function() {
				var i = jQuery(this);
				if(void 0 !== (t = i.attr("data-rule"))) {
					var e, t, s = !1,
						o = t.indexOf(":", 0);
					switch(t = 0 <= o ? (e = t.substr(o + 1, t.length), t.substr(0, o)) : t.substr(o + 1, t.length)) {
						case "required":
							"" === i.val() && (n = s = !0);
							break;
						case "minlen":
							i.val().length < parseInt(e) && (n = s = !0)
					}
					i.next(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? null != i.attr("data-msg") ? i.attr("data-msg") : "wrong Input" : "")).show(), s ? i.next(".validation").show() : i.next(".validation").hide()
				}
			}), e.each(function() {
				var i = jQuery(this);
				if(void 0 !== (t = i.attr("data-rule"))) {
					var e, t, s = !1,
						o = t.indexOf(":", 0);
					switch(t = 0 <= o ? (e = t.substr(o + 1, t.length), t.substr(0, o)) : t.substr(o + 1, t.length)) {
						case "required":
							"" === i.val() && (n = s = !0);
							break;
						case "minlen":
							i.val().length < parseInt(e) && (n = s = !0)
					}
					i.next(".validation").html('<i class="fa fa-info-circle"></i> &nbsp;' + (s ? null != i.attr("data-msg") ? i.attr("data-msg") : "wrong Input" : "")).show(), s ? i.next(".validation").show() : i.next(".validation").hide()
				}
			}), n) return !1; {
			const s = document.forms["save-subko-form"];
			$.ajax({
				url: "https://us-central1-moonshine-meadery-website.cloudfunctions.net/enquiry/create-order",
				type: "POST",
				crossDomain: !0,
				dataType: "json",
				data: $("#subkoForm").serializeArray(),
				success: function(i) {
					s.reset(), $.growlUI("Order Submitted Successfully!"), location.reload()
				},
				error: function(i, e, t) {
					console.log(i, e, t)
				}
			})
		}
		return !1
	}),
	function(r) {
		function n(i) {
			this.options = r.extend({
				container: null,
				hideOnClickOutside: !1,
				menuActiveClass: "nav-active",
				menuOpener: ".nav-opener",
				menuDrop: ".nav-drop",
				toggleEvent: "click",
				outsideClickEvent: "click touchstart pointerdown MSPointerDown"
			}, i), this.initStructure(), this.attachEvents()
		}
		n.prototype = {
			initStructure: function() {
				this.page = r("html"), this.container = r(this.options.container), this.opener = this.container.find(this.options.menuOpener), this.drop = this.container.find(this.options.menuDrop)
			},
			attachEvents: function() {
				var e = this;
				i && (i(), i = null), this.outsideClickHandler = function(i) {
					e.isOpened() && ((i = r(i.target)).closest(e.opener).length || i.closest(e.drop).length || e.hide())
				}, this.openerClickHandler = function(i) {
					i.preventDefault(), e.toggle()
				}, this.opener.on(this.options.toggleEvent, this.openerClickHandler)
			},
			isOpened: function() {
				return this.container.hasClass(this.options.menuActiveClass)
			},
			show: function() {
				this.container.addClass(this.options.menuActiveClass), this.options.hideOnClickOutside && this.page.on(this.options.outsideClickEvent, this.outsideClickHandler)
			},
			hide: function() {
				this.container.removeClass(this.options.menuActiveClass), this.options.hideOnClickOutside && this.page.off(this.options.outsideClickEvent, this.outsideClickHandler)
			},
			toggle: function() {
				this.isOpened() ? this.hide() : this.show()
			},
			destroy: function() {
				this.container.removeClass(this.options.menuActiveClass), this.opener.off(this.options.toggleEvent, this.clickHandler), this.page.off(this.options.outsideClickEvent, this.outsideClickHandler)
			}
		};
		var i = function() {
			function i() {
				e = !1, o.removeClass(n)
			}
			var e, t, s = r(window),
				o = r("html"),
				n = "resize-active";
			s.on("resize orientationchange", function() {
				e || (e = !0, o.addClass(n)), clearTimeout(t), t = setTimeout(i, 500)
			})
		};
		r.fn.mobileNav = function(t) {
			var s = Array.prototype.slice.call(arguments),
				o = s[0];
			return this.each(function() {
				var i = jQuery(this),
					e = i.data("MobileNav");
				"object" == typeof t || void 0 === t ? i.data("MobileNav", new n(r.extend({
					container: this
				}, t))) : "string" == typeof o && e && "function" == typeof e[o] && (s.shift(), e[o].apply(e, s))
			})
		}
	}(jQuery),
	function(i) {
		"use strict";
		"function" == typeof define && define.amd ? define(["jquery"], i) : "undefined" != typeof exports ? module.exports = i(require("jquery")) : i(jQuery)
	}(function(d) {
		"use strict";
		var s, r = window.Slick || {};
		s = 0, (r = function(i, e) {
			var t = this;
			t.defaults = {
				accessibility: !0,
				adaptiveHeight: !1,
				appendArrows: d(i),
				appendDots: d(i),
				arrows: !0,
				asNavFor: null,
				prevArrow: '<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',
				nextArrow: '<button class="slick-next" aria-label="Next" type="button">Next</button>',
				autoplay: !1,
				autoplaySpeed: 3e3,
				centerMode: !1,
				centerPadding: "50px",
				cssEase: "ease",
				customPaging: function(i, e) {
					return d('<button type="button" />').text(e + 1)
				},
				dots: !1,
				dotsClass: "slick-dots",
				draggable: !0,
				easing: "linear",
				edgeFriction: .35,
				fade: !1,
				focusOnSelect: !1,
				focusOnChange: !1,
				infinite: !0,
				initialSlide: 0,
				lazyLoad: "ondemand",
				mobileFirst: !1,
				pauseOnHover: !0,
				pauseOnFocus: !0,
				pauseOnDotsHover: !1,
				respondTo: "window",
				responsive: null,
				rows: 1,
				rtl: !1,
				slide: "",
				slidesPerRow: 1,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 500,
				swipe: !0,
				swipeToSlide: !1,
				touchMove: !0,
				touchThreshold: 5,
				useCSS: !0,
				useTransform: !0,
				variableWidth: !1,
				vertical: !1,
				verticalSwiping: !1,
				waitForAnimate: !0,
				zIndex: 1e3
			}, t.initials = {
				animating: !1,
				dragging: !1,
				autoPlayTimer: null,
				currentDirection: 0,
				currentLeft: null,
				currentSlide: 0,
				direction: 1,
				$dots: null,
				listWidth: null,
				listHeight: null,
				loadIndex: 0,
				$nextArrow: null,
				$prevArrow: null,
				scrolling: !1,
				slideCount: null,
				slideWidth: null,
				$slideTrack: null,
				$slides: null,
				sliding: !1,
				slideOffset: 0,
				swipeLeft: null,
				swiping: !1,
				$list: null,
				touchObject: {},
				transformsEnabled: !1,
				unslicked: !1
			}, d.extend(t, t.initials), t.activeBreakpoint = null, t.animType = null, t.animProp = null, t.breakpoints = [], t.breakpointSettings = [], t.cssTransitions = !1, t.focussed = !1, t.interrupted = !1, t.hidden = "hidden", t.paused = !0, t.positionProp = null, t.respondTo = null, t.rowCount = 1, t.shouldClick = !0, t.$slider = d(i), t.$slidesCache = null, t.transformType = null, t.transitionType = null, t.visibilityChange = "visibilitychange", t.windowWidth = 0, t.windowTimer = null, i = d(i).data("slick") || {}, t.options = d.extend({}, t.defaults, e, i), t.currentSlide = t.options.initialSlide, t.originalSettings = t.options, void 0 !== document.mozHidden ? (t.hidden = "mozHidden", t.visibilityChange = "mozvisibilitychange") : void 0 !== document.webkitHidden && (t.hidden = "webkitHidden", t.visibilityChange = "webkitvisibilitychange"), t.autoPlay = d.proxy(t.autoPlay, t), t.autoPlayClear = d.proxy(t.autoPlayClear, t), t.autoPlayIterator = d.proxy(t.autoPlayIterator, t), t.changeSlide = d.proxy(t.changeSlide, t), t.clickHandler = d.proxy(t.clickHandler, t), t.selectHandler = d.proxy(t.selectHandler, t), t.setPosition = d.proxy(t.setPosition, t), t.swipeHandler = d.proxy(t.swipeHandler, t), t.dragHandler = d.proxy(t.dragHandler, t), t.keyHandler = d.proxy(t.keyHandler, t), t.instanceUid = s++, t.htmlExpr = /^(?:\s*(<[\w\W]+>)[^>]*)$/, t.registerBreakpoints(), t.init(!0)
		}).prototype.activateADA = function() {
			this.$slideTrack.find(".slick-active").attr({
				"aria-hidden": "false"
			}).find("a, input, button, select").attr({
				tabindex: "0"
			})
		}, r.prototype.addSlide = r.prototype.slickAdd = function(i, e, t) {
			var s = this;
			if("boolean" == typeof e) t = e, e = null;
			else if(e < 0 || e >= s.slideCount) return !1;
			s.unload(), "number" == typeof e ? 0 === e && 0 === s.$slides.length ? d(i).appendTo(s.$slideTrack) : t ? d(i).insertBefore(s.$slides.eq(e)) : d(i).insertAfter(s.$slides.eq(e)) : !0 === t ? d(i).prependTo(s.$slideTrack) : d(i).appendTo(s.$slideTrack), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slides.each(function(i, e) {
				d(e).attr("data-slick-index", i)
			}), s.$slidesCache = s.$slides, s.reinit()
		}, r.prototype.animateHeight = function() {
			var i, e = this;
			1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical && (i = e.$slides.eq(e.currentSlide).outerHeight(!0), e.$list.animate({
				height: i
			}, e.options.speed))
		}, r.prototype.animateSlide = function(i, e) {
			var t = {},
				s = this;
			s.animateHeight(), !0 === s.options.rtl && !1 === s.options.vertical && (i = -i), !1 === s.transformsEnabled ? !1 === s.options.vertical ? s.$slideTrack.animate({
				left: i
			}, s.options.speed, s.options.easing, e) : s.$slideTrack.animate({
				top: i
			}, s.options.speed, s.options.easing, e) : !1 === s.cssTransitions ? (!0 === s.options.rtl && (s.currentLeft = -s.currentLeft), d({
				animStart: s.currentLeft
			}).animate({
				animStart: i
			}, {
				duration: s.options.speed,
				easing: s.options.easing,
				step: function(i) {
					i = Math.ceil(i), !1 === s.options.vertical ? t[s.animType] = "translate(" + i + "px, 0px)" : t[s.animType] = "translate(0px," + i + "px)", s.$slideTrack.css(t)
				},
				complete: function() {
					e && e.call()
				}
			})) : (s.applyTransition(), i = Math.ceil(i), !1 === s.options.vertical ? t[s.animType] = "translate3d(" + i + "px, 0px, 0px)" : t[s.animType] = "translate3d(0px," + i + "px, 0px)", s.$slideTrack.css(t), e && setTimeout(function() {
				s.disableTransition(), e.call()
			}, s.options.speed))
		}, r.prototype.getNavTarget = function() {
			var i = this.options.asNavFor;
			return i && null !== i && (i = d(i).not(this.$slider)), i
		}, r.prototype.asNavFor = function(e) {
			var i = this.getNavTarget();
			null !== i && "object" == typeof i && i.each(function() {
				var i = d(this).slick("getSlick");
				i.unslicked || i.slideHandler(e, !0)
			})
		}, r.prototype.applyTransition = function(i) {
			var e = this,
				t = {};
			!1 === e.options.fade ? t[e.transitionType] = e.transformType + " " + e.options.speed + "ms " + e.options.cssEase : t[e.transitionType] = "opacity " + e.options.speed + "ms " + e.options.cssEase, (!1 === e.options.fade ? e.$slideTrack : e.$slides.eq(i)).css(t)
		}, r.prototype.autoPlay = function() {
			var i = this;
			i.autoPlayClear(), i.slideCount > i.options.slidesToShow && (i.autoPlayTimer = setInterval(i.autoPlayIterator, i.options.autoplaySpeed))
		}, r.prototype.autoPlayClear = function() {
			this.autoPlayTimer && clearInterval(this.autoPlayTimer)
		}, r.prototype.autoPlayIterator = function() {
			var i = this,
				e = i.currentSlide + i.options.slidesToScroll;
			i.paused || i.interrupted || i.focussed || (!1 === i.options.infinite && (1 === i.direction && i.currentSlide + 1 === i.slideCount - 1 ? i.direction = 0 : 0 === i.direction && (e = i.currentSlide - i.options.slidesToScroll, i.currentSlide - 1 == 0 && (i.direction = 1))), i.slideHandler(e))
		}, r.prototype.buildArrows = function() {
			var i = this;
			!0 === i.options.arrows && (i.$prevArrow = d(i.options.prevArrow).addClass("slick-arrow"), i.$nextArrow = d(i.options.nextArrow).addClass("slick-arrow"), i.slideCount > i.options.slidesToShow ? (i.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), i.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"), i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.prependTo(i.options.appendArrows), i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.appendTo(i.options.appendArrows), !0 !== i.options.infinite && i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true")) : i.$prevArrow.add(i.$nextArrow).addClass("slick-hidden").attr({
				"aria-disabled": "true",
				tabindex: "-1"
			}))
		}, r.prototype.buildDots = function() {
			var i, e, t = this;
			if(!0 === t.options.dots && t.slideCount > t.options.slidesToShow) {
				for(t.$slider.addClass("slick-dotted"), e = d("<ul />").addClass(t.options.dotsClass), i = 0; i <= t.getDotCount(); i += 1) e.append(d("<li />").append(t.options.customPaging.call(this, t, i)));
				t.$dots = e.appendTo(t.options.appendDots), t.$dots.find("li").first().addClass("slick-active")
			}
		}, r.prototype.buildOut = function() {
			var i = this;
			i.$slides = i.$slider.children(i.options.slide + ":not(.slick-cloned)").addClass("slick-slide"), i.slideCount = i.$slides.length, i.$slides.each(function(i, e) {
				d(e).attr("data-slick-index", i).data("originalStyling", d(e).attr("style") || "")
			}), i.$slider.addClass("slick-slider"), i.$slideTrack = 0 === i.slideCount ? d('<div class="slick-track"/>').appendTo(i.$slider) : i.$slides.wrapAll('<div class="slick-track"/>').parent(), i.$list = i.$slideTrack.wrap('<div class="slick-list"/>').parent(), i.$slideTrack.css("opacity", 0), !0 !== i.options.centerMode && !0 !== i.options.swipeToSlide || (i.options.slidesToScroll = 1), d("img[data-lazy]", i.$slider).not("[src]").addClass("slick-loading"), i.setupInfinite(), i.buildArrows(), i.buildDots(), i.updateDots(), i.setSlideClasses("number" == typeof i.currentSlide ? i.currentSlide : 0), !0 === i.options.draggable && i.$list.addClass("draggable")
		}, r.prototype.buildRows = function() {
			var i, e, t, s = this,
				o = document.createDocumentFragment(),
				n = s.$slider.children();
			if(0 < s.options.rows) {
				for(t = s.options.slidesPerRow * s.options.rows, e = Math.ceil(n.length / t), i = 0; i < e; i++) {
					for(var r = document.createElement("div"), a = 0; a < s.options.rows; a++) {
						for(var l = document.createElement("div"), d = 0; d < s.options.slidesPerRow; d++) {
							var p = i * t + (a * s.options.slidesPerRow + d);
							n.get(p) && l.appendChild(n.get(p))
						}
						r.appendChild(l)
					}
					o.appendChild(r)
				}
				s.$slider.empty().append(o), s.$slider.children().children().children().css({
					width: 100 / s.options.slidesPerRow + "%",
					display: "inline-block"
				})
			}
		}, r.prototype.checkResponsive = function(i, e) {
			var t, s, o, n = this,
				r = !1,
				a = n.$slider.width(),
				l = window.innerWidth || d(window).width();
			if("window" === n.respondTo ? o = l : "slider" === n.respondTo ? o = a : "min" === n.respondTo && (o = Math.min(l, a)), n.options.responsive && n.options.responsive.length && null !== n.options.responsive) {
				for(t in s = null, n.breakpoints) n.breakpoints.hasOwnProperty(t) && (!1 === n.originalSettings.mobileFirst ? o < n.breakpoints[t] && (s = n.breakpoints[t]) : o > n.breakpoints[t] && (s = n.breakpoints[t]));
				null !== s ? null !== n.activeBreakpoint && s === n.activeBreakpoint && !e || (n.activeBreakpoint = s, "unslick" === n.breakpointSettings[s] ? n.unslick(s) : (n.options = d.extend({}, n.originalSettings, n.breakpointSettings[s]), !0 === i && (n.currentSlide = n.options.initialSlide), n.refresh(i)), r = s) : null !== n.activeBreakpoint && (n.activeBreakpoint = null, n.options = n.originalSettings, !0 === i && (n.currentSlide = n.options.initialSlide), n.refresh(i), r = s), i || !1 === r || n.$slider.trigger("breakpoint", [n, r])
			}
		}, r.prototype.changeSlide = function(i, e) {
			var t, s = this,
				o = d(i.currentTarget);
			switch(o.is("a") && i.preventDefault(), o.is("li") || (o = o.closest("li")), t = s.slideCount % s.options.slidesToScroll != 0 ? 0 : (s.slideCount - s.currentSlide) % s.options.slidesToScroll, i.data.message) {
				case "previous":
					n = 0 == t ? s.options.slidesToScroll : s.options.slidesToShow - t, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide - n, !1, e);
					break;
				case "next":
					n = 0 == t ? s.options.slidesToScroll : t, s.slideCount > s.options.slidesToShow && s.slideHandler(s.currentSlide + n, !1, e);
					break;
				case "index":
					var n = 0 === i.data.index ? 0 : i.data.index || o.index() * s.options.slidesToScroll;
					s.slideHandler(s.checkNavigable(n), !1, e), o.children().trigger("focus");
					break;
				default:
					return
			}
		}, r.prototype.checkNavigable = function(i) {
			var e = this.getNavigableIndexes(),
				t = 0;
			if(i > e[e.length - 1]) i = e[e.length - 1];
			else
				for(var s in e) {
					if(i < e[s]) {
						i = t;
						break
					}
					t = e[s]
				}
			return i
		}, r.prototype.cleanUpEvents = function() {
			var i = this;
			i.options.dots && null !== i.$dots && (d("li", i.$dots).off("click.slick", i.changeSlide).off("mouseenter.slick", d.proxy(i.interrupt, i, !0)).off("mouseleave.slick", d.proxy(i.interrupt, i, !1)), !0 === i.options.accessibility && i.$dots.off("keydown.slick", i.keyHandler)), i.$slider.off("focus.slick blur.slick"), !0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow && i.$prevArrow.off("click.slick", i.changeSlide), i.$nextArrow && i.$nextArrow.off("click.slick", i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow && i.$prevArrow.off("keydown.slick", i.keyHandler), i.$nextArrow && i.$nextArrow.off("keydown.slick", i.keyHandler))), i.$list.off("touchstart.slick mousedown.slick", i.swipeHandler), i.$list.off("touchmove.slick mousemove.slick", i.swipeHandler), i.$list.off("touchend.slick mouseup.slick", i.swipeHandler), i.$list.off("touchcancel.slick mouseleave.slick", i.swipeHandler), i.$list.off("click.slick", i.clickHandler), d(document).off(i.visibilityChange, i.visibility), i.cleanUpSlideEvents(), !0 === i.options.accessibility && i.$list.off("keydown.slick", i.keyHandler), !0 === i.options.focusOnSelect && d(i.$slideTrack).children().off("click.slick", i.selectHandler), d(window).off("orientationchange.slick.slick-" + i.instanceUid, i.orientationChange), d(window).off("resize.slick.slick-" + i.instanceUid, i.resize), d("[draggable!=true]", i.$slideTrack).off("dragstart", i.preventDefault), d(window).off("load.slick.slick-" + i.instanceUid, i.setPosition)
		}, r.prototype.cleanUpSlideEvents = function() {
			var i = this;
			i.$list.off("mouseenter.slick", d.proxy(i.interrupt, i, !0)), i.$list.off("mouseleave.slick", d.proxy(i.interrupt, i, !1))
		}, r.prototype.cleanUpRows = function() {
			var i;
			0 < this.options.rows && ((i = this.$slides.children().children()).removeAttr("style"), this.$slider.empty().append(i))
		}, r.prototype.clickHandler = function(i) {
			!1 === this.shouldClick && (i.stopImmediatePropagation(), i.stopPropagation(), i.preventDefault())
		}, r.prototype.destroy = function(i) {
			var e = this;
			e.autoPlayClear(), e.touchObject = {}, e.cleanUpEvents(), d(".slick-cloned", e.$slider).detach(), e.$dots && e.$dots.remove(), e.$prevArrow && e.$prevArrow.length && (e.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), e.htmlExpr.test(e.options.prevArrow) && e.$prevArrow.remove()), e.$nextArrow && e.$nextArrow.length && (e.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display", ""), e.htmlExpr.test(e.options.nextArrow) && e.$nextArrow.remove()), e.$slides && (e.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function() {
				d(this).attr("style", d(this).data("originalStyling"))
			}), e.$slideTrack.children(this.options.slide).detach(), e.$slideTrack.detach(), e.$list.detach(), e.$slider.append(e.$slides)), e.cleanUpRows(), e.$slider.removeClass("slick-slider"), e.$slider.removeClass("slick-initialized"), e.$slider.removeClass("slick-dotted"), e.unslicked = !0, i || e.$slider.trigger("destroy", [e])
		}, r.prototype.disableTransition = function(i) {
			var e = {};
			e[this.transitionType] = "", (!1 === this.options.fade ? this.$slideTrack : this.$slides.eq(i)).css(e)
		}, r.prototype.fadeSlide = function(i, e) {
			var t = this;
			!1 === t.cssTransitions ? (t.$slides.eq(i).css({
				zIndex: t.options.zIndex
			}), t.$slides.eq(i).animate({
				opacity: 1
			}, t.options.speed, t.options.easing, e)) : (t.applyTransition(i), t.$slides.eq(i).css({
				opacity: 1,
				zIndex: t.options.zIndex
			}), e && setTimeout(function() {
				t.disableTransition(i), e.call()
			}, t.options.speed))
		}, r.prototype.fadeSlideOut = function(i) {
			var e = this;
			!1 === e.cssTransitions ? e.$slides.eq(i).animate({
				opacity: 0,
				zIndex: e.options.zIndex - 2
			}, e.options.speed, e.options.easing) : (e.applyTransition(i), e.$slides.eq(i).css({
				opacity: 0,
				zIndex: e.options.zIndex - 2
			}))
		}, r.prototype.filterSlides = r.prototype.slickFilter = function(i) {
			var e = this;
			null !== i && (e.$slidesCache = e.$slides, e.unload(), e.$slideTrack.children(this.options.slide).detach(), e.$slidesCache.filter(i).appendTo(e.$slideTrack), e.reinit())
		}, r.prototype.focusHandler = function() {
			var t = this;
			t.$slider.off("focus.slick blur.slick").on("focus.slick", "*", function(i) {
				var e = d(this);
				setTimeout(function() {
					t.options.pauseOnFocus && e.is(":focus") && (t.focussed = !0, t.autoPlay())
				}, 0)
			}).on("blur.slick", "*", function(i) {
				d(this), t.options.pauseOnFocus && (t.focussed = !1, t.autoPlay())
			})
		}, r.prototype.getCurrent = r.prototype.slickCurrentSlide = function() {
			return this.currentSlide
		}, r.prototype.getDotCount = function() {
			var i = this,
				e = 0,
				t = 0,
				s = 0;
			if(!0 === i.options.infinite)
				if(i.slideCount <= i.options.slidesToShow) ++s;
				else
					for(; e < i.slideCount;) ++s, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
			else if(!0 === i.options.centerMode) s = i.slideCount;
			else if(i.options.asNavFor)
				for(; e < i.slideCount;) ++s, e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
			else s = 1 + Math.ceil((i.slideCount - i.options.slidesToShow) / i.options.slidesToScroll);
			return s - 1
		}, r.prototype.getLeft = function(i) {
			var e, t, s = this,
				o = 0;
			return s.slideOffset = 0, e = s.$slides.first().outerHeight(!0), !0 === s.options.infinite ? (s.slideCount > s.options.slidesToShow && (s.slideOffset = s.slideWidth * s.options.slidesToShow * -1, t = -1, !0 === s.options.vertical && !0 === s.options.centerMode && (2 === s.options.slidesToShow ? t = -1.5 : 1 === s.options.slidesToShow && (t = -2)), o = e * s.options.slidesToShow * t), s.slideCount % s.options.slidesToScroll != 0 && i + s.options.slidesToScroll > s.slideCount && s.slideCount > s.options.slidesToShow && (o = i > s.slideCount ? (s.slideOffset = (s.options.slidesToShow - (i - s.slideCount)) * s.slideWidth * -1, (s.options.slidesToShow - (i - s.slideCount)) * e * -1) : (s.slideOffset = s.slideCount % s.options.slidesToScroll * s.slideWidth * -1, s.slideCount % s.options.slidesToScroll * e * -1))) : i + s.options.slidesToShow > s.slideCount && (s.slideOffset = (i + s.options.slidesToShow - s.slideCount) * s.slideWidth, o = (i + s.options.slidesToShow - s.slideCount) * e), s.slideCount <= s.options.slidesToShow && (o = s.slideOffset = 0), !0 === s.options.centerMode && s.slideCount <= s.options.slidesToShow ? s.slideOffset = s.slideWidth * Math.floor(s.options.slidesToShow) / 2 - s.slideWidth * s.slideCount / 2 : !0 === s.options.centerMode && !0 === s.options.infinite ? s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2) - s.slideWidth : !0 === s.options.centerMode && (s.slideOffset = 0, s.slideOffset += s.slideWidth * Math.floor(s.options.slidesToShow / 2)), e = !1 === s.options.vertical ? i * s.slideWidth * -1 + s.slideOffset : i * e * -1 + o, !0 === s.options.variableWidth && (o = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow), e = !0 === s.options.rtl ? o[0] ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, !0 === s.options.centerMode && (o = s.slideCount <= s.options.slidesToShow || !1 === s.options.infinite ? s.$slideTrack.children(".slick-slide").eq(i) : s.$slideTrack.children(".slick-slide").eq(i + s.options.slidesToShow + 1), e = !0 === s.options.rtl ? o[0] ? -1 * (s.$slideTrack.width() - o[0].offsetLeft - o.width()) : 0 : o[0] ? -1 * o[0].offsetLeft : 0, e += (s.$list.width() - o.outerWidth()) / 2)), e
		}, r.prototype.getOption = r.prototype.slickGetOption = function(i) {
			return this.options[i]
		}, r.prototype.getNavigableIndexes = function() {
			for(var i = this, e = 0, t = 0, s = [], o = !1 === i.options.infinite ? i.slideCount : (e = -1 * i.options.slidesToScroll, t = -1 * i.options.slidesToScroll, 2 * i.slideCount); e < o;) s.push(e), e = t + i.options.slidesToScroll, t += i.options.slidesToScroll <= i.options.slidesToShow ? i.options.slidesToScroll : i.options.slidesToShow;
			return s
		}, r.prototype.getSlick = function() {
			return this
		}, r.prototype.getSlideCount = function() {
			var o, n = this,
				i = !0 === n.options.centerMode ? Math.floor(n.$list.width() / 2) : 0,
				r = -1 * n.swipeLeft + i;
			return !0 === n.options.swipeToSlide ? (n.$slideTrack.find(".slick-slide").each(function(i, e) {
				var t = d(e).outerWidth(),
					s = e.offsetLeft;
				if(!0 !== n.options.centerMode && (s += t / 2), r < s + t) return o = e, !1
			}), Math.abs(d(o).attr("data-slick-index") - n.currentSlide) || 1) : n.options.slidesToScroll
		}, r.prototype.goTo = r.prototype.slickGoTo = function(i, e) {
			this.changeSlide({
				data: {
					message: "index",
					index: parseInt(i)
				}
			}, e)
		}, r.prototype.init = function(i) {
			var e = this;
			d(e.$slider).hasClass("slick-initialized") || (d(e.$slider).addClass("slick-initialized"), e.buildRows(), e.buildOut(), e.setProps(), e.startLoad(), e.loadSlider(), e.initializeEvents(), e.updateArrows(), e.updateDots(), e.checkResponsive(!0), e.focusHandler()), i && e.$slider.trigger("init", [e]), !0 === e.options.accessibility && e.initADA(), e.options.autoplay && (e.paused = !1, e.autoPlay())
		}, r.prototype.initADA = function() {
			var t = this,
				s = Math.ceil(t.slideCount / t.options.slidesToShow),
				o = t.getNavigableIndexes().filter(function(i) {
					return 0 <= i && i < t.slideCount
				});
			t.$slides.add(t.$slideTrack.find(".slick-cloned")).attr({
				"aria-hidden": "true",
				tabindex: "-1"
			}).find("a, input, button, select").attr({
				tabindex: "-1"
			}), null !== t.$dots && (t.$slides.not(t.$slideTrack.find(".slick-cloned")).each(function(i) {
				var e = o.indexOf(i);
				d(this).attr({
					role: "tabpanel",
					id: "slick-slide" + t.instanceUid + i,
					tabindex: -1
				}), -1 !== e && (e = "slick-slide-control" + t.instanceUid + e, d("#" + e).length && d(this).attr({
					"aria-describedby": e
				}))
			}), t.$dots.attr("role", "tablist").find("li").each(function(i) {
				var e = o[i];
				d(this).attr({
					role: "presentation"
				}), d(this).find("button").first().attr({
					role: "tab",
					id: "slick-slide-control" + t.instanceUid + i,
					"aria-controls": "slick-slide" + t.instanceUid + e,
					"aria-label": i + 1 + " of " + s,
					"aria-selected": null,
					tabindex: "-1"
				})
			}).eq(t.currentSlide).find("button").attr({
				"aria-selected": "true",
				tabindex: "0"
			}).end());
			for(var i = t.currentSlide, e = i + t.options.slidesToShow; i < e; i++) t.options.focusOnChange ? t.$slides.eq(i).attr({
				tabindex: "0"
			}) : t.$slides.eq(i).removeAttr("tabindex");
			t.activateADA()
		}, r.prototype.initArrowEvents = function() {
			var i = this;
			!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.off("click.slick").on("click.slick", {
				message: "previous"
			}, i.changeSlide), i.$nextArrow.off("click.slick").on("click.slick", {
				message: "next"
			}, i.changeSlide), !0 === i.options.accessibility && (i.$prevArrow.on("keydown.slick", i.keyHandler), i.$nextArrow.on("keydown.slick", i.keyHandler)))
		}, r.prototype.initDotEvents = function() {
			var i = this;
			!0 === i.options.dots && i.slideCount > i.options.slidesToShow && (d("li", i.$dots).on("click.slick", {
				message: "index"
			}, i.changeSlide), !0 === i.options.accessibility && i.$dots.on("keydown.slick", i.keyHandler)), !0 === i.options.dots && !0 === i.options.pauseOnDotsHover && i.slideCount > i.options.slidesToShow && d("li", i.$dots).on("mouseenter.slick", d.proxy(i.interrupt, i, !0)).on("mouseleave.slick", d.proxy(i.interrupt, i, !1))
		}, r.prototype.initSlideEvents = function() {
			var i = this;
			i.options.pauseOnHover && (i.$list.on("mouseenter.slick", d.proxy(i.interrupt, i, !0)), i.$list.on("mouseleave.slick", d.proxy(i.interrupt, i, !1)))
		}, r.prototype.initializeEvents = function() {
			var i = this;
			i.initArrowEvents(), i.initDotEvents(), i.initSlideEvents(), i.$list.on("touchstart.slick mousedown.slick", {
				action: "start"
			}, i.swipeHandler), i.$list.on("touchmove.slick mousemove.slick", {
				action: "move"
			}, i.swipeHandler), i.$list.on("touchend.slick mouseup.slick", {
				action: "end"
			}, i.swipeHandler), i.$list.on("touchcancel.slick mouseleave.slick", {
				action: "end"
			}, i.swipeHandler), i.$list.on("click.slick", i.clickHandler), d(document).on(i.visibilityChange, d.proxy(i.visibility, i)), !0 === i.options.accessibility && i.$list.on("keydown.slick", i.keyHandler), !0 === i.options.focusOnSelect && d(i.$slideTrack).children().on("click.slick", i.selectHandler), d(window).on("orientationchange.slick.slick-" + i.instanceUid, d.proxy(i.orientationChange, i)), d(window).on("resize.slick.slick-" + i.instanceUid, d.proxy(i.resize, i)), d("[draggable!=true]", i.$slideTrack).on("dragstart", i.preventDefault), d(window).on("load.slick.slick-" + i.instanceUid, i.setPosition), d(i.setPosition)
		}, r.prototype.initUI = function() {
			var i = this;
			!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.show(), i.$nextArrow.show()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.show()
		}, r.prototype.keyHandler = function(i) {
			var e = this;
			i.target.tagName.match("TEXTAREA|INPUT|SELECT") || (37 === i.keyCode && !0 === e.options.accessibility ? e.changeSlide({
				data: {
					message: !0 === e.options.rtl ? "next" : "previous"
				}
			}) : 39 === i.keyCode && !0 === e.options.accessibility && e.changeSlide({
				data: {
					message: !0 === e.options.rtl ? "previous" : "next"
				}
			}))
		}, r.prototype.lazyLoad = function() {
			function i(i) {
				d("img[data-lazy]", i).each(function() {
					var i = d(this),
						e = d(this).attr("data-lazy"),
						t = d(this).attr("data-srcset"),
						s = d(this).attr("data-sizes") || n.$slider.attr("data-sizes"),
						o = document.createElement("img");
					o.onload = function() {
						i.animate({
							opacity: 0
						}, 100, function() {
							t && (i.attr("srcset", t), s && i.attr("sizes", s)), i.attr("src", e).animate({
								opacity: 1
							}, 200, function() {
								i.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")
							}), n.$slider.trigger("lazyLoaded", [n, i, e])
						})
					}, o.onerror = function() {
						i.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, i, e])
					}, o.src = e
				})
			}
			var e, t, s, n = this;
			if(!0 === n.options.centerMode ? s = !0 === n.options.infinite ? (t = n.currentSlide + (n.options.slidesToShow / 2 + 1)) + n.options.slidesToShow + 2 : (t = Math.max(0, n.currentSlide - (n.options.slidesToShow / 2 + 1)), n.options.slidesToShow / 2 + 1 + 2 + n.currentSlide) : (t = n.options.infinite ? n.options.slidesToShow + n.currentSlide : n.currentSlide, s = Math.ceil(t + n.options.slidesToShow), !0 === n.options.fade && (0 < t && t--, s <= n.slideCount && s++)), e = n.$slider.find(".slick-slide").slice(t, s), "anticipated" === n.options.lazyLoad)
				for(var o = t - 1, r = s, a = n.$slider.find(".slick-slide"), l = 0; l < n.options.slidesToScroll; l++) o < 0 && (o = n.slideCount - 1), e = (e = e.add(a.eq(o))).add(a.eq(r)), o--, r++;
			i(e), n.slideCount <= n.options.slidesToShow ? i(n.$slider.find(".slick-slide")) : n.currentSlide >= n.slideCount - n.options.slidesToShow ? i(n.$slider.find(".slick-cloned").slice(0, n.options.slidesToShow)) : 0 === n.currentSlide && i(n.$slider.find(".slick-cloned").slice(-1 * n.options.slidesToShow))
		}, r.prototype.loadSlider = function() {
			var i = this;
			i.setPosition(), i.$slideTrack.css({
				opacity: 1
			}), i.$slider.removeClass("slick-loading"), i.initUI(), "progressive" === i.options.lazyLoad && i.progressiveLazyLoad()
		}, r.prototype.next = r.prototype.slickNext = function() {
			this.changeSlide({
				data: {
					message: "next"
				}
			})
		}, r.prototype.orientationChange = function() {
			this.checkResponsive(), this.setPosition()
		}, r.prototype.pause = r.prototype.slickPause = function() {
			this.autoPlayClear(), this.paused = !0
		}, r.prototype.play = r.prototype.slickPlay = function() {
			var i = this;
			i.autoPlay(), i.options.autoplay = !0, i.paused = !1, i.focussed = !1, i.interrupted = !1
		}, r.prototype.postSlide = function(i) {
			var e = this;
			!e.unslicked && (e.$slider.trigger("afterChange", [e, i]), e.animating = !1, e.slideCount > e.options.slidesToShow && e.setPosition(), e.swipeLeft = null, e.options.autoplay && e.autoPlay(), !0 === e.options.accessibility && (e.initADA(), e.options.focusOnChange)) && d(e.$slides.get(e.currentSlide)).attr("tabindex", 0).focus()
		}, r.prototype.prev = r.prototype.slickPrev = function() {
			this.changeSlide({
				data: {
					message: "previous"
				}
			})
		}, r.prototype.preventDefault = function(i) {
			i.preventDefault()
		}, r.prototype.progressiveLazyLoad = function(i) {
			i = i || 1;
			var e, t, s, o, n = this,
				r = d("img[data-lazy]", n.$slider);
			r.length ? (e = r.first(), t = e.attr("data-lazy"), s = e.attr("data-srcset"), o = e.attr("data-sizes") || n.$slider.attr("data-sizes"), (r = document.createElement("img")).onload = function() {
				s && (e.attr("srcset", s), o && e.attr("sizes", o)), e.attr("src", t).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"), !0 === n.options.adaptiveHeight && n.setPosition(), n.$slider.trigger("lazyLoaded", [n, e, t]), n.progressiveLazyLoad()
			}, r.onerror = function() {
				i < 3 ? setTimeout(function() {
					n.progressiveLazyLoad(i + 1)
				}, 500) : (e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"), n.$slider.trigger("lazyLoadError", [n, e, t]), n.progressiveLazyLoad())
			}, r.src = t) : n.$slider.trigger("allImagesLoaded", [n])
		}, r.prototype.refresh = function(i) {
			var e = this,
				t = e.slideCount - e.options.slidesToShow;
			!e.options.infinite && e.currentSlide > t && (e.currentSlide = t), e.slideCount <= e.options.slidesToShow && (e.currentSlide = 0), t = e.currentSlide, e.destroy(!0), d.extend(e, e.initials, {
				currentSlide: t
			}), e.init(), i || e.changeSlide({
				data: {
					message: "index",
					index: t
				}
			}, !1)
		}, r.prototype.registerBreakpoints = function() {
			var i, e, t, s = this,
				o = s.options.responsive || null;
			if("array" === d.type(o) && o.length) {
				for(i in s.respondTo = s.options.respondTo || "window", o)
					if(t = s.breakpoints.length - 1, o.hasOwnProperty(i)) {
						for(e = o[i].breakpoint; 0 <= t;) s.breakpoints[t] && s.breakpoints[t] === e && s.breakpoints.splice(t, 1), t--;
						s.breakpoints.push(e), s.breakpointSettings[e] = o[i].settings
					}
				s.breakpoints.sort(function(i, e) {
					return s.options.mobileFirst ? i - e : e - i
				})
			}
		}, r.prototype.reinit = function() {
			var i = this;
			i.$slides = i.$slideTrack.children(i.options.slide).addClass("slick-slide"), i.slideCount = i.$slides.length, i.currentSlide >= i.slideCount && 0 !== i.currentSlide && (i.currentSlide = i.currentSlide - i.options.slidesToScroll), i.slideCount <= i.options.slidesToShow && (i.currentSlide = 0), i.registerBreakpoints(), i.setProps(), i.setupInfinite(), i.buildArrows(), i.updateArrows(), i.initArrowEvents(), i.buildDots(), i.updateDots(), i.initDotEvents(), i.cleanUpSlideEvents(), i.initSlideEvents(), i.checkResponsive(!1, !0), !0 === i.options.focusOnSelect && d(i.$slideTrack).children().on("click.slick", i.selectHandler), i.setSlideClasses("number" == typeof i.currentSlide ? i.currentSlide : 0), i.setPosition(), i.focusHandler(), i.paused = !i.options.autoplay, i.autoPlay(), i.$slider.trigger("reInit", [i])
		}, r.prototype.resize = function() {
			var i = this;
			d(window).width() !== i.windowWidth && (clearTimeout(i.windowDelay), i.windowDelay = window.setTimeout(function() {
				i.windowWidth = d(window).width(), i.checkResponsive(), i.unslicked || i.setPosition()
			}, 50))
		}, r.prototype.removeSlide = r.prototype.slickRemove = function(i, e, t) {
			var s = this;
			return i = "boolean" == typeof i ? !0 === (e = i) ? 0 : s.slideCount - 1 : !0 === e ? --i : i, !(s.slideCount < 1 || i < 0 || i > s.slideCount - 1) && (s.unload(), (!0 === t ? s.$slideTrack.children() : s.$slideTrack.children(this.options.slide).eq(i)).remove(), s.$slides = s.$slideTrack.children(this.options.slide), s.$slideTrack.children(this.options.slide).detach(), s.$slideTrack.append(s.$slides), s.$slidesCache = s.$slides, void s.reinit())
		}, r.prototype.setCSS = function(i) {
			var e, t, s = this,
				o = {};
			!0 === s.options.rtl && (i = -i), e = "left" == s.positionProp ? Math.ceil(i) + "px" : "0px", t = "top" == s.positionProp ? Math.ceil(i) + "px" : "0px", o[s.positionProp] = i, !1 === s.transformsEnabled || (!(o = {}) === s.cssTransitions ? o[s.animType] = "translate(" + e + ", " + t + ")" : o[s.animType] = "translate3d(" + e + ", " + t + ", 0px)"), s.$slideTrack.css(o)
		}, r.prototype.setDimensions = function() {
			var i = this;
			!1 === i.options.vertical ? !0 === i.options.centerMode && i.$list.css({
				padding: "0px " + i.options.centerPadding
			}) : (i.$list.height(i.$slides.first().outerHeight(!0) * i.options.slidesToShow), !0 === i.options.centerMode && i.$list.css({
				padding: i.options.centerPadding + " 0px"
			})), i.listWidth = i.$list.width(), i.listHeight = i.$list.height(), !1 === i.options.vertical && !1 === i.options.variableWidth ? (i.slideWidth = Math.ceil(i.listWidth / i.options.slidesToShow), i.$slideTrack.width(Math.ceil(i.slideWidth * i.$slideTrack.children(".slick-slide").length))) : !0 === i.options.variableWidth ? i.$slideTrack.width(5e3 * i.slideCount) : (i.slideWidth = Math.ceil(i.listWidth), i.$slideTrack.height(Math.ceil(i.$slides.first().outerHeight(!0) * i.$slideTrack.children(".slick-slide").length)));
			var e = i.$slides.first().outerWidth(!0) - i.$slides.first().width();
			!1 === i.options.variableWidth && i.$slideTrack.children(".slick-slide").width(i.slideWidth - e)
		}, r.prototype.setFade = function() {
			var t, s = this;
			s.$slides.each(function(i, e) {
				t = s.slideWidth * i * -1, !0 === s.options.rtl ? d(e).css({
					position: "relative",
					right: t,
					top: 0,
					zIndex: s.options.zIndex - 2,
					opacity: 0
				}) : d(e).css({
					position: "relative",
					left: t,
					top: 0,
					zIndex: s.options.zIndex - 2,
					opacity: 0
				})
			}), s.$slides.eq(s.currentSlide).css({
				zIndex: s.options.zIndex - 1,
				opacity: 1
			})
		}, r.prototype.setHeight = function() {
			var i, e = this;
			1 === e.options.slidesToShow && !0 === e.options.adaptiveHeight && !1 === e.options.vertical && (i = e.$slides.eq(e.currentSlide).outerHeight(!0), e.$list.css("height", i))
		}, r.prototype.setOption = r.prototype.slickSetOption = function() {
			var i, e, t, s, o, n = this,
				r = !1;
			if("object" === d.type(arguments[0]) ? (t = arguments[0], r = arguments[1], o = "multiple") : "string" === d.type(arguments[0]) && (t = arguments[0], s = arguments[1], r = arguments[2], "responsive" === arguments[0] && "array" === d.type(arguments[1]) ? o = "responsive" : void 0 !== arguments[1] && (o = "single")), "single" === o) n.options[t] = s;
			else if("multiple" === o) d.each(t, function(i, e) {
				n.options[i] = e
			});
			else if("responsive" === o)
				for(e in s)
					if("array" !== d.type(n.options.responsive)) n.options.responsive = [s[e]];
					else {
						for(i = n.options.responsive.length - 1; 0 <= i;) n.options.responsive[i].breakpoint === s[e].breakpoint && n.options.responsive.splice(i, 1), i--;
						n.options.responsive.push(s[e])
					}
			r && (n.unload(), n.reinit())
		}, r.prototype.setPosition = function() {
			var i = this;
			i.setDimensions(), i.setHeight(), !1 === i.options.fade ? i.setCSS(i.getLeft(i.currentSlide)) : i.setFade(), i.$slider.trigger("setPosition", [i])
		}, r.prototype.setProps = function() {
			var i = this,
				e = document.body.style;
			i.positionProp = !0 === i.options.vertical ? "top" : "left", "top" === i.positionProp ? i.$slider.addClass("slick-vertical") : i.$slider.removeClass("slick-vertical"), void 0 === e.WebkitTransition && void 0 === e.MozTransition && void 0 === e.msTransition || !0 === i.options.useCSS && (i.cssTransitions = !0), i.options.fade && ("number" == typeof i.options.zIndex ? i.options.zIndex < 3 && (i.options.zIndex = 3) : i.options.zIndex = i.defaults.zIndex), void 0 !== e.OTransform && (i.animType = "OTransform", i.transformType = "-o-transform", i.transitionType = "OTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.MozTransform && (i.animType = "MozTransform", i.transformType = "-moz-transform", i.transitionType = "MozTransition", void 0 === e.perspectiveProperty && void 0 === e.MozPerspective && (i.animType = !1)), void 0 !== e.webkitTransform && (i.animType = "webkitTransform", i.transformType = "-webkit-transform", i.transitionType = "webkitTransition", void 0 === e.perspectiveProperty && void 0 === e.webkitPerspective && (i.animType = !1)), void 0 !== e.msTransform && (i.animType = "msTransform", i.transformType = "-ms-transform", i.transitionType = "msTransition", void 0 === e.msTransform && (i.animType = !1)), void 0 !== e.transform && !1 !== i.animType && (i.animType = "transform", i.transformType = "transform", i.transitionType = "transition"), i.transformsEnabled = i.options.useTransform && null !== i.animType && !1 !== i.animType
		}, r.prototype.setSlideClasses = function(i) {
			var e, t, s, o = this,
				n = o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden", "true");
			o.$slides.eq(i).addClass("slick-current"), !0 === o.options.centerMode ? (t = o.options.slidesToShow % 2 == 0 ? 1 : 0, s = Math.floor(o.options.slidesToShow / 2), !0 === o.options.infinite && (s <= i && i <= o.slideCount - 1 - s ? o.$slides.slice(i - s + t, i + s + 1).addClass("slick-active").attr("aria-hidden", "false") : (e = o.options.slidesToShow + i, n.slice(e - s + 1 + t, e + s + 2).addClass("slick-active").attr("aria-hidden", "false")), 0 === i ? n.eq(n.length - 1 - o.options.slidesToShow).addClass("slick-center") : i === o.slideCount - 1 && n.eq(o.options.slidesToShow).addClass("slick-center")), o.$slides.eq(i).addClass("slick-center")) : 0 <= i && i <= o.slideCount - o.options.slidesToShow ? o.$slides.slice(i, i + o.options.slidesToShow).addClass("slick-active").attr("aria-hidden", "false") : n.length <= o.options.slidesToShow ? n.addClass("slick-active").attr("aria-hidden", "false") : (s = o.slideCount % o.options.slidesToShow, e = !0 === o.options.infinite ? o.options.slidesToShow + i : i, (o.options.slidesToShow == o.options.slidesToScroll && o.slideCount - i < o.options.slidesToShow ? n.slice(e - (o.options.slidesToShow - s), e + s) : n.slice(e, e + o.options.slidesToShow)).addClass("slick-active").attr("aria-hidden", "false")), "ondemand" !== o.options.lazyLoad && "anticipated" !== o.options.lazyLoad || o.lazyLoad()
		}, r.prototype.setupInfinite = function() {
			var i, e, t, s = this;
			if(!0 === s.options.fade && (s.options.centerMode = !1), !0 === s.options.infinite && !1 === s.options.fade && (e = null, s.slideCount > s.options.slidesToShow)) {
				for(t = !0 === s.options.centerMode ? s.options.slidesToShow + 1 : s.options.slidesToShow, i = s.slideCount; i > s.slideCount - t; --i) e = i - 1, d(s.$slides[e]).clone(!0).attr("id", "").attr("data-slick-index", e - s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");
				for(i = 0; i < t + s.slideCount; i += 1) e = i, d(s.$slides[e]).clone(!0).attr("id", "").attr("data-slick-index", e + s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");
				s.$slideTrack.find(".slick-cloned").find("[id]").each(function() {
					d(this).attr("id", "")
				})
			}
		}, r.prototype.interrupt = function(i) {
			i || this.autoPlay(), this.interrupted = i
		}, r.prototype.selectHandler = function(i) {
			i = d(i.target).is(".slick-slide") ? d(i.target) : d(i.target).parents(".slick-slide"), i = (i = parseInt(i.attr("data-slick-index"))) || 0;
			return this.slideCount <= this.options.slidesToShow ? void this.slideHandler(i, !1, !0) : void this.slideHandler(i)
		}, r.prototype.slideHandler = function(i, e, t) {
			var s, o, n, r = this;
			if(e = e || !1, !(!0 === r.animating && !0 === r.options.waitForAnimate || !0 === r.options.fade && r.currentSlide === i)) return !1 === e && r.asNavFor(i), s = i, n = r.getLeft(s), e = r.getLeft(r.currentSlide), r.currentLeft = null === r.swipeLeft ? e : r.swipeLeft, !1 === r.options.infinite && !1 === r.options.centerMode && (i < 0 || i > r.getDotCount() * r.options.slidesToScroll) || !1 === r.options.infinite && !0 === r.options.centerMode && (i < 0 || i > r.slideCount - r.options.slidesToScroll) ? void(!1 === r.options.fade && (s = r.currentSlide, !0 !== t && r.slideCount > r.options.slidesToShow ? r.animateSlide(e, function() {
				r.postSlide(s)
			}) : r.postSlide(s))) : (r.options.autoplay && clearInterval(r.autoPlayTimer), o = s < 0 ? r.slideCount % r.options.slidesToScroll != 0 ? r.slideCount - r.slideCount % r.options.slidesToScroll : r.slideCount + s : s >= r.slideCount ? r.slideCount % r.options.slidesToScroll != 0 ? 0 : s - r.slideCount : s, r.animating = !0, r.$slider.trigger("beforeChange", [r, r.currentSlide, o]), i = r.currentSlide, r.currentSlide = o, r.setSlideClasses(r.currentSlide), r.options.asNavFor && ((e = (e = r.getNavTarget()).slick("getSlick")).slideCount <= e.options.slidesToShow && e.setSlideClasses(r.currentSlide)), r.updateDots(), r.updateArrows(), !0 === r.options.fade ? (!0 !== t ? (r.fadeSlideOut(i), r.fadeSlide(o, function() {
				r.postSlide(o)
			})) : r.postSlide(o), void r.animateHeight()) : void(!0 !== t && r.slideCount > r.options.slidesToShow ? r.animateSlide(n, function() {
				r.postSlide(o)
			}) : r.postSlide(o)))
		}, r.prototype.startLoad = function() {
			var i = this;
			!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && (i.$prevArrow.hide(), i.$nextArrow.hide()), !0 === i.options.dots && i.slideCount > i.options.slidesToShow && i.$dots.hide(), i.$slider.addClass("slick-loading")
		}, r.prototype.swipeDirection = function() {
			var i = this,
				e = i.touchObject.startX - i.touchObject.curX,
				t = i.touchObject.startY - i.touchObject.curY,
				e = Math.atan2(t, e),
				e = Math.round(180 * e / Math.PI);
			return e < 0 && (e = 360 - Math.abs(e)), e <= 45 && 0 <= e || e <= 360 && 315 <= e ? !1 === i.options.rtl ? "left" : "right" : 135 <= e && e <= 225 ? !1 === i.options.rtl ? "right" : "left" : !0 === i.options.verticalSwiping ? 35 <= e && e <= 135 ? "down" : "up" : "vertical"
		}, r.prototype.swipeEnd = function(i) {
			var e, t, s = this;
			if(s.dragging = !1, s.swiping = !1, s.scrolling) return s.scrolling = !1;
			if(s.interrupted = !1, s.shouldClick = !(10 < s.touchObject.swipeLength), void 0 === s.touchObject.curX) return !1;
			if(!0 === s.touchObject.edgeHit && s.$slider.trigger("edge", [s, s.swipeDirection()]), s.touchObject.swipeLength >= s.touchObject.minSwipe) {
				switch(t = s.swipeDirection()) {
					case "left":
					case "down":
						e = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide + s.getSlideCount()) : s.currentSlide + s.getSlideCount(), s.currentDirection = 0;
						break;
					case "right":
					case "up":
						e = s.options.swipeToSlide ? s.checkNavigable(s.currentSlide - s.getSlideCount()) : s.currentSlide - s.getSlideCount(), s.currentDirection = 1
				}
				"vertical" != t && (s.slideHandler(e), s.touchObject = {}, s.$slider.trigger("swipe", [s, t]))
			} else s.touchObject.startX !== s.touchObject.curX && (s.slideHandler(s.currentSlide), s.touchObject = {})
		}, r.prototype.swipeHandler = function(i) {
			var e = this;
			if(!(!1 === e.options.swipe || "ontouchend" in document && !1 === e.options.swipe || !1 === e.options.draggable && -1 !== i.type.indexOf("mouse"))) switch(e.touchObject.fingerCount = i.originalEvent && void 0 !== i.originalEvent.touches ? i.originalEvent.touches.length : 1, e.touchObject.minSwipe = e.listWidth / e.options.touchThreshold, !0 === e.options.verticalSwiping && (e.touchObject.minSwipe = e.listHeight / e.options.touchThreshold), i.data.action) {
				case "start":
					e.swipeStart(i);
					break;
				case "move":
					e.swipeMove(i);
					break;
				case "end":
					e.swipeEnd(i)
			}
		}, r.prototype.swipeMove = function(i) {
			var e, t, s = this,
				o = void 0 !== i.originalEvent ? i.originalEvent.touches : null;
			return !(!s.dragging || s.scrolling || o && 1 !== o.length) && (e = s.getLeft(s.currentSlide), s.touchObject.curX = void 0 !== o ? o[0].pageX : i.clientX, s.touchObject.curY = void 0 !== o ? o[0].pageY : i.clientY, s.touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(s.touchObject.curX - s.touchObject.startX, 2))), t = Math.round(Math.sqrt(Math.pow(s.touchObject.curY - s.touchObject.startY, 2))), !s.options.verticalSwiping && !s.swiping && 4 < t ? !(s.scrolling = !0) : (!0 === s.options.verticalSwiping && (s.touchObject.swipeLength = t), o = s.swipeDirection(), void 0 !== i.originalEvent && 4 < s.touchObject.swipeLength && (s.swiping = !0, i.preventDefault()), t = (!1 === s.options.rtl ? 1 : -1) * (s.touchObject.curX > s.touchObject.startX ? 1 : -1), !0 === s.options.verticalSwiping && (t = s.touchObject.curY > s.touchObject.startY ? 1 : -1), i = s.touchObject.swipeLength, (s.touchObject.edgeHit = !1) === s.options.infinite && (0 === s.currentSlide && "right" === o || s.currentSlide >= s.getDotCount() && "left" === o) && (i = s.touchObject.swipeLength * s.options.edgeFriction, s.touchObject.edgeHit = !0), !1 === s.options.vertical ? s.swipeLeft = e + i * t : s.swipeLeft = e + i * (s.$list.height() / s.listWidth) * t, !0 === s.options.verticalSwiping && (s.swipeLeft = e + i * t), !0 !== s.options.fade && !1 !== s.options.touchMove && (!0 === s.animating ? (s.swipeLeft = null, !1) : void s.setCSS(s.swipeLeft))))
		}, r.prototype.swipeStart = function(i) {
			var e, t = this;
			return t.interrupted = !0, 1 !== t.touchObject.fingerCount || t.slideCount <= t.options.slidesToShow ? !(t.touchObject = {}) : (void 0 !== i.originalEvent && void 0 !== i.originalEvent.touches && (e = i.originalEvent.touches[0]), t.touchObject.startX = t.touchObject.curX = void 0 !== e ? e.pageX : i.clientX, t.touchObject.startY = t.touchObject.curY = void 0 !== e ? e.pageY : i.clientY, void(t.dragging = !0))
		}, r.prototype.unfilterSlides = r.prototype.slickUnfilter = function() {
			var i = this;
			null !== i.$slidesCache && (i.unload(), i.$slideTrack.children(this.options.slide).detach(), i.$slidesCache.appendTo(i.$slideTrack), i.reinit())
		}, r.prototype.unload = function() {
			var i = this;
			d(".slick-cloned", i.$slider).remove(), i.$dots && i.$dots.remove(), i.$prevArrow && i.htmlExpr.test(i.options.prevArrow) && i.$prevArrow.remove(), i.$nextArrow && i.htmlExpr.test(i.options.nextArrow) && i.$nextArrow.remove(), i.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden", "true").css("width", "")
		}, r.prototype.unslick = function(i) {
			this.$slider.trigger("unslick", [this, i]), this.destroy()
		}, r.prototype.updateArrows = function() {
			var i = this;
			Math.floor(i.options.slidesToShow / 2);
			!0 === i.options.arrows && i.slideCount > i.options.slidesToShow && !i.options.infinite && (i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false"), 0 === i.currentSlide ? (i.$prevArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$nextArrow.removeClass("slick-disabled").attr("aria-disabled", "false")) : (i.currentSlide >= i.slideCount - i.options.slidesToShow && !1 === i.options.centerMode || i.currentSlide >= i.slideCount - 1 && !0 === i.options.centerMode) && (i.$nextArrow.addClass("slick-disabled").attr("aria-disabled", "true"), i.$prevArrow.removeClass("slick-disabled").attr("aria-disabled", "false")))
		}, r.prototype.updateDots = function() {
			var i = this;
			null !== i.$dots && (i.$dots.find("li").removeClass("slick-active").end(), i.$dots.find("li").eq(Math.floor(i.currentSlide / i.options.slidesToScroll)).addClass("slick-active"))
		}, r.prototype.visibility = function() {
			this.options.autoplay && (document[this.hidden] ? this.interrupted = !0 : this.interrupted = !1)
		}, d.fn.slick = function() {
			for(var i, e = this, t = arguments[0], s = Array.prototype.slice.call(arguments, 1), o = e.length, n = 0; n < o; n++)
				if("object" == typeof t || void 0 === t ? e[n].slick = new r(e[n], t) : i = e[n].slick[t].apply(e[n].slick, s), void 0 !== i) return i;
			return e
		}
	});

$(document).on('change', '.input-file', function(e) {
      $(this).parent().addClass('file-added');
      var fileName = e.target.files[0].name;
      console.log(fileName);
      jQuery(this).parent().find('.file-uloader').html(fileName);
    });


/*
 * jQuery Accordion plugin new
 */
;(function(root, factory) {

	'use strict';
	if (typeof define === 'function' && define.amd) {
		define(['jquery'], factory);
	} else if (typeof exports === 'object') {
		module.exports = factory(require('jquery'));
	} else {
		root.SlideAccordion = factory(jQuery);
	}
}(window, function($) {

	'use strict';
	var accHiddenClass = 'js-acc-hidden';

	function SlideAccordion(options) {
		this.options = $.extend(true, {
			allowClickWhenExpanded: false,
			activeClass:'active',
			opener:'.opener',
			slider:'.slide',
			animSpeed: 300,
			collapsible:true,
			event: 'click',
			scrollToActiveItem: {
				enable: false,
				breakpoint: 767, // max-width
				animSpeed: 600,
				extraOffset: null
			}
		}, options);
		this.init();
	}

	SlideAccordion.prototype = {
		init: function() {
			if (this.options.holder) {
				this.findElements();
				this.setStateOnInit();
				this.attachEvents();
				this.makeCallback('onInit');
			}
		},

		findElements: function() {
			this.$holder = $(this.options.holder).data('SlideAccordion', this);
			this.$items = this.$holder.find(':has(' + this.options.slider + ')');
		},

		setStateOnInit: function() {
			var self = this;

			this.$items.each(function() {
				if (!$(this).hasClass(self.options.activeClass)) {
					$(this).find(self.options.slider).addClass(accHiddenClass);
				}
			});
		},

		attachEvents: function() {
			var self = this;

			this.accordionToggle = function(e) {
				var $item = jQuery(this).closest(self.$items);
				var $actiItem = self.getActiveItem($item);

				if (!self.options.allowClickWhenExpanded || !$item.hasClass(self.options.activeClass)) {
					e.preventDefault();
					self.toggle($item, $actiItem);
				}
			};

			this.$items.on(this.options.event, this.options.opener, this.accordionToggle);
		},

		toggle: function($item, $prevItem) {
			if (!$item.hasClass(this.options.activeClass)) {
				this.show($item);
			} else if (this.options.collapsible) {
				this.hide($item);
			}

			if (!$item.is($prevItem) && $prevItem.length) {
				this.hide($prevItem);
			}

			this.makeCallback('beforeToggle');
		},

		show: function($item) {
			var $slider = $item.find(this.options.slider);

			$item.addClass(this.options.activeClass);
			$slider.stop().hide().removeClass(accHiddenClass).slideDown({
				duration: this.options.animSpeed,
				complete: function() {
					$slider.removeAttr('style');
					if (
						this.options.scrollToActiveItem.enable &&
						window.innerWidth <= this.options.scrollToActiveItem.breakpoint
					) {
						this.goToItem($item);
					}
					this.makeCallback('onShow', $item);
				}.bind(this)
			});

			this.makeCallback('beforeShow', $item);
		},

		hide: function($item) {
			var $slider = $item.find(this.options.slider);

			$item.removeClass(this.options.activeClass);
			$slider.stop().show().slideUp({
				duration: this.options.animSpeed,
				complete: function() {
					$slider.addClass(accHiddenClass);
					$slider.removeAttr('style');
					this.makeCallback('onHide', $item);
				}.bind(this)
			});

			this.makeCallback('beforeHide', $item);
		},

		goToItem: function($item) {
			var itemOffset = $item.offset().top;

			if (itemOffset < $(window).scrollTop()) {
				// handle extra offset
				if (typeof this.options.scrollToActiveItem.extraOffset === 'number') {
					itemOffset -= this.options.scrollToActiveItem.extraOffset;
				} else if (typeof this.options.scrollToActiveItem.extraOffset === 'function') {
					itemOffset -= this.options.scrollToActiveItem.extraOffset();
				}

				$('body, html').animate({
					scrollTop: itemOffset
				}, this.options.scrollToActiveItem.animSpeed);
			}
		},

		getActiveItem: function($item) {
			return $item.siblings().filter('.' + this.options.activeClass);
		},

		makeCallback: function(name) {
			if (typeof this.options[name] === 'function') {
				var args = Array.prototype.slice.call(arguments);
				args.shift();
				this.options[name].apply(this, args);
			}
		},

		destroy: function() {
			this.$holder.removeData('SlideAccordion');
			this.$items.off(this.options.event, this.options.opener, this.accordionToggle);
			this.$items.removeClass(this.options.activeClass).each(function(i, item) {
				$(item).find(this.options.slider).removeAttr('style').removeClass(accHiddenClass);
			}.bind(this));
			this.makeCallback('onDestroy');
		}
	};

	$.fn.slideAccordion = function(opt) {
		var args = Array.prototype.slice.call(arguments);
		var method = args[0];

		return this.each(function() {
			var $holder = jQuery(this);
			var instance = $holder.data('SlideAccordion');

			if (typeof opt === 'object' || typeof opt === 'undefined') {
				new SlideAccordion($.extend(true, {
					holder: this
				}, opt));
			} else if (typeof method === 'string' && instance) {
				if(typeof instance[method] === 'function') {
					args.shift();
					instance[method].apply(instance, args);
				}
			}
		});
	};

	(function() {
		var tabStyleSheet = $('<style type="text/css">')[0];
		var tabStyleRule = '.' + accHiddenClass;
		tabStyleRule += '{position:absolute !important;left:-9999px !important;top:-9999px !important;display:block !important; width: 100% !important;}';
		if (tabStyleSheet.styleSheet) {
			tabStyleSheet.styleSheet.cssText = tabStyleRule;
		} else {
			tabStyleSheet.appendChild(document.createTextNode(tabStyleRule));
		}
		$('head').append(tabStyleSheet);
	}());

	return SlideAccordion;
}));